import React, { createContext, useState, useEffect, useContext } from "react";
import { EDUCATION_LINK, SKILLS_LINK, SUMMARY_LINK, WORKHISTORY_LINK } from "../constants/constants";
import _ from "lodash";

const CoverLetterContext = createContext({});

export const CoverLetterProvider = (props) => {
    const [showPreview, setShowPreview] = useState(false);
   //check all shared props + container for below files
    // wp-content/themes/resumebuilder/builder/src/initial-data.jsx
    // wp-content/themes/resumebuilder/builder/src/containers/EditorContainer.jsx
    const toggleSkip = name => {
    }

    const toggleProfilePicture = () => {
  
    }

    return (
        <CoverLetterContext.Provider value={{...props, toggleSkip, toggleProfilePicture, showPreview,  setShowPreview}}>
            {props.children}
        </CoverLetterContext.Provider>)
}//
//export default ResumeContext;
export const useCoverLetter = () => {
    const context = useContext(CoverLetterContext);
    return context;
}
